import { adFetch } from 'adalConfig';
import { useQuery } from 'react-query';

export const useGetUsers = () => {
  const q = useQuery(['users'], () => adFetch<Record<string, string>>('/users'), { staleTime: Infinity });
  return q;
};
